// src/Dashboard/pages/user/CalendarEvents/components/CalendarEventRegistrationPanel.jsx

import React from "react";
import { FaTimes } from "react-icons/fa";

import { formatDateRange } from "../utils/calendarEventsUtils";

export default function CalendarEventRegistrationPanel({
  event,
  canRegister,

  panelMode,
  setPanelMode,

  selectedAdherent,
  setSelectedAdherent,

  eligibleForRegister = [],
  eligibleForUnregister = [],

  submitting,

  onClose,
  onConfirmRegistration,
  onConfirmUnregister,
}) {
  return (
    <div className="mt-4 overflow-hidden rounded-[22px] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900/80">
      <div className="flex items-start justify-between gap-3 border-b border-slate-200 px-4 py-3 dark:border-slate-800">
        <div>
          <p className="text-sm font-bold text-slate-900 dark:text-white">
            Gérer l’inscription
          </p>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            {formatDateRange(event)}
          </p>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white text-slate-600 ring-1 ring-slate-200 transition hover:bg-slate-100 dark:bg-slate-950 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-800"
          title="Fermer"
        >
          <FaTimes />
        </button>
      </div>

      <div className="p-4">
        <div className="mb-4 inline-flex overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-950">
          <button
            type="button"
            disabled={!canRegister}
            onClick={() => {
              setPanelMode("register");
              setSelectedAdherent("");
            }}
            className={`px-4 py-2 text-sm font-bold transition ${
              panelMode === "register"
                ? "bg-[#013E8E] text-white"
                : "text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800"
            } ${!canRegister ? "cursor-not-allowed opacity-50" : ""}`}
            title={!canRegister ? "Inscriptions closes" : "Inscrire"}
          >
            Inscrire
          </button>

          <button
            type="button"
            onClick={() => {
              setPanelMode("unregister");
              setSelectedAdherent("");
            }}
            className={`px-4 py-2 text-sm font-bold transition ${
              panelMode === "unregister"
                ? "bg-[#013E8E] text-white"
                : "text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800"
            }`}
          >
            Désinscrire
          </button>
        </div>

        {panelMode === "register" ? (
          !canRegister ? (
            <div className="rounded-2xl bg-red-50 p-4 text-sm text-red-700 ring-1 ring-red-200 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20">
              Les inscriptions sont closes pour cet événement. Vous pouvez
              uniquement gérer une désinscription.
            </div>
          ) : (
            <div>
              <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
                Adhérent à inscrire
              </label>

              <select
                value={selectedAdherent}
                onChange={(eventSelect) =>
                  setSelectedAdherent(eventSelect.target.value)
                }
                className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              >
                <option value="">Sélectionner un adhérent</option>

                {eligibleForRegister.map((adherent) => (
                  <option key={adherent.id} value={adherent.id}>
                    {adherent.nom} {adherent.prenom}
                  </option>
                ))}
              </select>

              {eligibleForRegister.length === 0 && (
                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  Aucun adhérent disponible à inscrire.
                </p>
              )}
            </div>
          )
        ) : (
          <div>
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Adhérent à désinscrire
            </label>

            <select
              value={selectedAdherent}
              onChange={(eventSelect) =>
                setSelectedAdherent(eventSelect.target.value)
              }
              className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value="">Sélectionner un adhérent</option>

              {eligibleForUnregister.map((adherent) => (
                <option key={adherent.id} value={adherent.id}>
                  {adherent.nom} {adherent.prenom}
                </option>
              ))}
            </select>

            {eligibleForUnregister.length === 0 && (
              <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                Aucun adhérent éligible à la désinscription.
              </p>
            )}
          </div>
        )}

        <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Annuler
          </button>

          {panelMode === "register" ? (
            <button
              type="button"
              onClick={onConfirmRegistration}
              disabled={!selectedAdherent || !canRegister || submitting}
              className="rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white transition hover:bg-indigo-800 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {submitting ? "Traitement..." : "Confirmer l’inscription"}
            </button>
          ) : (
            <button
              type="button"
              onClick={onConfirmUnregister}
              disabled={!selectedAdherent || submitting}
              className="rounded-2xl bg-red-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {submitting ? "Traitement..." : "Confirmer la désinscription"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}